exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.custom-disabled[data-v-5fcc495c] {\n    box-shadow: none !important;\n    pointer-events: none;\n}\n", ""]);

// exports
